import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//fonction de récupération des fichier export je pilote
async function getExportCatalogue(){
	this.fullscreenLoading = true
	var date = moment().format("DD-MM-YYYY")
	this.axios.post(conf.server+"/api/getExportCatalogue",{},{withCredentials:true, responseType:'blob'})
	.then((response) => {
		var link = document.createElement('a');
		link.download = 'Catalogue_'+date+'.xlsx';
		link.href = URL.createObjectURL(response.data);
		document.documentElement.appendChild(link).click();
		document.documentElement.removeChild(link);
		this.fullscreenLoading = false
	})
	.catch((error) => {
		console.dir(error)
		if(error.response.status == 999){
			toasterError(`Les cotations doivent être des chiffres`,'Problème de données')
		}
		else if(error.response != undefined){
			if(error.response.status == 401 || error.response.status == 400){
				this.$router.push('/');
			}
			toasterError(`Impossible de charger les informations`,'Chargement des paramètres par défaut')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
		this.fullscreenLoading = false
	})
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default{
    getExportCatalogue
}

